import { useCallback, useMemo } from 'react';
import {
  ReactFlow,
  Background,
  type Node,
  type Edge,
  type NodeTypes,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';

import { PhaseNode } from './PhaseNode';
import type { PhaseFlowNode } from './types';

interface FlowDiagramProps {
  nodes: PhaseFlowNode[];
  edges: Edge[];
  onNodeClick: (nodeId: string) => void;
}

export function FlowDiagram({ nodes, edges, onNodeClick }: FlowDiagramProps) {
  const nodeTypes: NodeTypes = useMemo(() => ({
    phaseNode: PhaseNode,
  }), []);

  const handleNodeClick = useCallback(
    (_: React.MouseEvent, node: Node) => {
      onNodeClick(node.id);
    },
    [onNodeClick]
  );

  return (
    <div className="h-full w-full">
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        onNodeClick={handleNodeClick}
        fitView
        fitViewOptions={{
          padding: 0.1,
          includeHiddenNodes: false,
          minZoom: 0.5,
          maxZoom: 1,
        }}
        proOptions={{ hideAttribution: true }}
        nodesDraggable={false}
        nodesConnectable={false}
        elementsSelectable={false}
        panOnDrag={false}
        zoomOnScroll={false}
        zoomOnPinch={false}
        zoomOnDoubleClick={false}
        preventScrolling={false}
        minZoom={0.5}
        maxZoom={1.5}
      >
        <Background color="#e2e8f0" gap={16} />
      </ReactFlow>
    </div>
  );
}
